import { errorPlayerNotCreated, playOptions, } from './utils';
export const playerPlayUrl = async (player, parameters) => {
    if (!player) {
        throw errorPlayerNotCreated;
    }
    await player.playUrl(parameters.url, parameters.licenseUrl ?? null, playOptions(parameters.options));
};
